import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import ItemBoundable from './ItemBoundable';
import PriorityQueue from '../../util/PriorityQueue';
import hasInterface from '../../../../../hasInterface';
import SpatialIndex from '../SpatialIndex';
import AbstractNode from './AbstractNode';
import Double from '../../../../../java/lang/Double';
import Collections from '../../../../../java/util/Collections';
import BoundablePair from './BoundablePair';
import ArrayList from '../../../../../java/util/ArrayList';
import Comparator from '../../../../../java/util/Comparator';
import Serializable from '../../../../../java/io/Serializable';
import Envelope from '../../geom/Envelope';
import Assert from '../../util/Assert';
import AbstractSTRtree from './AbstractSTRtree';
import ItemDistance from './ItemDistance';
var STRtree = /*#__PURE__*/function (_AbstractSTRtree) {
  _inherits(STRtree, _AbstractSTRtree);
  function STRtree() {
    var _this;
    _classCallCheck(this, STRtree);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(STRtree).call(this));
    STRtree.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(STRtree, [{
    key: "createParentBoundablesFromVerticalSlices",
    value: function createParentBoundablesFromVerticalSlices(verticalSlices, newLevel) {
      Assert.isTrue(verticalSlices.length > 0);
      var parentBoundables = new ArrayList();
      for (var i = 0; i < verticalSlices.length; i++) parentBoundables.addAll(this.createParentBoundablesFromVerticalSlice(verticalSlices[i], newLevel));
      return parentBoundables;
    }
  }, {
    key: "nearestNeighbourK",
    value: function nearestNeighbourK() {
      if (arguments.length === 2) {
        var initBndPair = arguments[0],
          k = arguments[1];
        return this.nearestNeighbourK(initBndPair, Double.POSITIVE_INFINITY, k);
      } else if (arguments.length === 3) {
        var _initBndPair = arguments[0],
          maxDistance = arguments[1],
          _k = arguments[2];
        var distanceLowerBound = maxDistance;
        var priQ = new PriorityQueue();
        priQ.add(_initBndPair);
        var kNearestNeighbors = new PriorityQueue();
        while (!priQ.isEmpty() && distanceLowerBound >= 0.0) {
          var bndPair = priQ.poll();
          var pairDistance = bndPair.getDistance();
          if (pairDistance >= distanceLowerBound) break;
          if (bndPair.isLeaves()) {
            if (kNearestNeighbors.size() < _k) {
              kNearestNeighbors.add(bndPair);
            } else {
              var bp1 = kNearestNeighbors.peek();
              if (bp1.getDistance() > pairDistance) {
                kNearestNeighbors.poll();
                kNearestNeighbors.add(bndPair);
              }
              var bp2 = kNearestNeighbors.peek();
              distanceLowerBound = bp2.getDistance();
            }
          } else bndPair.expandToQueue(priQ, distanceLowerBound);
        }
        return STRtree.getItems(kNearestNeighbors);
      }
    }
  }, {
    key: "createNode",
    value: function createNode(level) {
      return new STRtreeNode(level);
    }
  }, {
    key: "size",
    value: function size() {
      if (arguments.length === 0) return _get(_getPrototypeOf(STRtree.prototype), "size", this).call(this);else return _get(_getPrototypeOf(STRtree.prototype), "size", this).apply(this, arguments);
    }
  }, {
    key: "insert",
    value: function insert() {
      if (arguments.length === 2 && arguments[1] instanceof Object && arguments[0] instanceof Envelope) {
        var itemEnv = arguments[0],
          item = arguments[1];
        if (itemEnv.isNull()) return null;
        _get(_getPrototypeOf(STRtree.prototype), "insert", this).call(this, itemEnv, item);
      } else {
        return _get(_getPrototypeOf(STRtree.prototype), "insert", this).apply(this, arguments);
      }
    }
  }, {
    key: "getIntersectsOp",
    value: function getIntersectsOp() {
      return STRtree.intersectsOp;
    }
  }, {
    key: "verticalSlices",
    value: function verticalSlices(childBoundables, sliceCount) {
      var sliceCapacity = Math.trunc(Math.ceil(childBoundables.size() / sliceCount));
      var slices = new Array(sliceCount).fill(null);
      var i = childBoundables.iterator();
      for (var j = 0; j < sliceCount; j++) {
        slices[j] = new ArrayList();
        var boundablesAddedToSlice = 0;
        while (i.hasNext() && boundablesAddedToSlice < sliceCapacity) {
          var childBoundable = i.next();
          slices[j].add(childBoundable);
          boundablesAddedToSlice++;
        }
      }
      return slices;
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 1) {
        var searchEnv = arguments[0];
        return _get(_getPrototypeOf(STRtree.prototype), "query", this).call(this, searchEnv);
      } else if (arguments.length === 2) {
        var _searchEnv = arguments[0],
          visitor = arguments[1];
        _get(_getPrototypeOf(STRtree.prototype), "query", this).call(this, _searchEnv, visitor);
      }
    }
  }, {
    key: "getComparator",
    value: function getComparator() {
      return STRtree.yComparator;
    }
  }, {
    key: "createParentBoundablesFromVerticalSlice",
    value: function createParentBoundablesFromVerticalSlice(childBoundables, newLevel) {
      return _get(_getPrototypeOf(STRtree.prototype), "createParentBoundables", this).call(this, childBoundables, newLevel);
    }
  }, {
    key: "remove",
    value: function remove() {
      if (arguments.length === 2 && arguments[1] instanceof Object && arguments[0] instanceof Envelope) {
        var itemEnv = arguments[0],
          item = arguments[1];
        return _get(_getPrototypeOf(STRtree.prototype), "remove", this).call(this, itemEnv, item);
      } else {
        return _get(_getPrototypeOf(STRtree.prototype), "remove", this).apply(this, arguments);
      }
    }
  }, {
    key: "depth",
    value: function depth() {
      if (arguments.length === 0) return _get(_getPrototypeOf(STRtree.prototype), "depth", this).call(this);else return _get(_getPrototypeOf(STRtree.prototype), "depth", this).apply(this, arguments);
    }
  }, {
    key: "createParentBoundables",
    value: function createParentBoundables(childBoundables, newLevel) {
      Assert.isTrue(!childBoundables.isEmpty());
      var minLeafCount = Math.trunc(Math.ceil(childBoundables.size() / this.getNodeCapacity()));
      var sortedChildBoundables = new ArrayList(childBoundables);
      Collections.sort(sortedChildBoundables, STRtree.xComparator);
      var verticalSlices = this.verticalSlices(sortedChildBoundables, Math.trunc(Math.ceil(Math.sqrt(minLeafCount))));
      return this.createParentBoundablesFromVerticalSlices(verticalSlices, newLevel);
    }
  }, {
    key: "nearestNeighbour",
    value: function nearestNeighbour() {
      if (arguments.length === 1) {
        if (hasInterface(arguments[0], ItemDistance)) {
          var itemDist = arguments[0];
          if (this.isEmpty()) return null;
          var bp = new BoundablePair(this.getRoot(), this.getRoot(), itemDist);
          return this.nearestNeighbour(bp);
        } else if (arguments[0] instanceof BoundablePair) {
          var initBndPair = arguments[0];
          var distanceLowerBound = Double.POSITIVE_INFINITY;
          var minPair = null;
          var priQ = new PriorityQueue();
          priQ.add(initBndPair);
          while (!priQ.isEmpty() && distanceLowerBound > 0.0) {
            var bndPair = priQ.poll();
            var pairDistance = bndPair.getDistance();
            if (pairDistance >= distanceLowerBound) break;
            if (bndPair.isLeaves()) {
              distanceLowerBound = pairDistance;
              minPair = bndPair;
            } else {
              bndPair.expandToQueue(priQ, distanceLowerBound);
            }
          }
          if (minPair === null) return null;
          return [minPair.getBoundable(0).getItem(), minPair.getBoundable(1).getItem()];
        }
      } else if (arguments.length === 2) {
        var tree = arguments[0],
          _itemDist = arguments[1];
        if (this.isEmpty() || tree.isEmpty()) return null;
        var _bp = new BoundablePair(this.getRoot(), tree.getRoot(), _itemDist);
        return this.nearestNeighbour(_bp);
      } else if (arguments.length === 3) {
        var env = arguments[0],
          item = arguments[1],
          _itemDist2 = arguments[2];
        var bnd = new ItemBoundable(env, item);
        var _bp2 = new BoundablePair(this.getRoot(), bnd, _itemDist2);
        return this.nearestNeighbour(_bp2)[0];
      } else if (arguments.length === 4) {
        var _env = arguments[0],
          _item = arguments[1],
          _itemDist3 = arguments[2],
          k = arguments[3];
        var _bnd = new ItemBoundable(_env, _item);
        var _bp3 = new BoundablePair(this.getRoot(), _bnd, _itemDist3);
        return this.nearestNeighbourK(_bp3, k);
      }
    }
  }, {
    key: "isWithinDistance",
    value: function isWithinDistance() {
      if (arguments.length === 2) {
        var initBndPair = arguments[0],
          maxDistance = arguments[1];
        var distanceUpperBound = Double.POSITIVE_INFINITY;
        var priQ = new PriorityQueue();
        priQ.add(initBndPair);
        while (!priQ.isEmpty()) {
          var bndPair = priQ.poll();
          var pairDistance = bndPair.getDistance();
          if (pairDistance > maxDistance) return false;
          if (bndPair.maximumDistance() <= maxDistance) return true;
          if (bndPair.isLeaves()) {
            distanceUpperBound = pairDistance;
            if (distanceUpperBound <= maxDistance) return true;
          } else {
            bndPair.expandToQueue(priQ, distanceUpperBound);
          }
        }
        return false;
      } else if (arguments.length === 3) {
        var tree = arguments[0],
          itemDist = arguments[1],
          _maxDistance = arguments[2];
        var bp = new BoundablePair(this.getRoot(), tree.getRoot(), itemDist);
        return this.isWithinDistance(bp, _maxDistance);
      }
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SpatialIndex, Serializable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      if (arguments.length === 0) {
        STRtree.constructor_.call(this, STRtree.DEFAULT_NODE_CAPACITY);
      } else if (arguments.length === 1) {
        var nodeCapacity = arguments[0];
        AbstractSTRtree.constructor_.call(this, nodeCapacity);
      }
    }
  }, {
    key: "centreX",
    value: function centreX(e) {
      return STRtree.avg(e.getMinX(), e.getMaxX());
    }
  }, {
    key: "avg",
    value: function avg(a, b) {
      return (a + b) / 2;
    }
  }, {
    key: "getItems",
    value: function getItems(kNearestNeighbors) {
      var items = new Array(kNearestNeighbors.size()).fill(null);
      var count = 0;
      while (!kNearestNeighbors.isEmpty()) {
        var bp = kNearestNeighbors.poll();
        items[count] = bp.getBoundable(0).getItem();
        count++;
      }
      return items;
    }
  }, {
    key: "centreY",
    value: function centreY(e) {
      return STRtree.avg(e.getMinY(), e.getMaxY());
    }
  }]);
  return STRtree;
}(AbstractSTRtree);
export { STRtree as default };
var STRtreeNode = /*#__PURE__*/function (_AbstractNode) {
  _inherits(STRtreeNode, _AbstractNode);
  function STRtreeNode() {
    var _this2;
    _classCallCheck(this, STRtreeNode);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(STRtreeNode).call(this));
    STRtreeNode.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this2)), arguments);
    return _this2;
  }
  _createClass(STRtreeNode, [{
    key: "computeBounds",
    value: function computeBounds() {
      var bounds = null;
      for (var i = this.getChildBoundables().iterator(); i.hasNext();) {
        var childBoundable = i.next();
        if (bounds === null) bounds = new Envelope(childBoundable.getBounds());else bounds.expandToInclude(childBoundable.getBounds());
      }
      return bounds;
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      var level = arguments[0];
      AbstractNode.constructor_.call(this, level);
    }
  }]);
  return STRtreeNode;
}(AbstractNode);
STRtree.STRtreeNode = STRtreeNode;
STRtree.xComparator = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  _createClass(_class, [{
    key: "compare",
    value: function compare(o1, o2) {
      return AbstractSTRtree.compareDoubles(STRtree.centreX(o1.getBounds()), STRtree.centreX(o2.getBounds()));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
  return _class;
}())();
STRtree.yComparator = new ( /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }
  _createClass(_class2, [{
    key: "compare",
    value: function compare(o1, o2) {
      return AbstractSTRtree.compareDoubles(STRtree.centreY(o1.getBounds()), STRtree.centreY(o2.getBounds()));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
  return _class2;
}())();
STRtree.intersectsOp = new ( /*#__PURE__*/function () {
  function _class3() {
    _classCallCheck(this, _class3);
  }
  _createClass(_class3, [{
    key: "intersects",
    value: function intersects(aBounds, bBounds) {
      return aBounds.intersects(bBounds);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [IntersectsOp];
    }
  }]);
  return _class3;
}())();
STRtree.DEFAULT_NODE_CAPACITY = 10;